export default "__VITE_ASSET__BSI2UiY4__"